import './App.css';
// import { BrowserRouter } from "react-router";
import AppRoutes from './router';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true,     // animate only once
    });
  }, []);
  return (
    // <BrowserRouter>
    <AppRoutes />
    // </BrowserRouter>
  );
}

export default App;
